import type { InjectionKey } from 'vue';
import type { StepperRegistry } from './useStepperRegistry';

/**
 * Stepper context provided by `NxStepper` to its `NxStep` children. A
 * module-level key is enough: provide/inject isolates by component hierarchy,
 * so nested/sibling steppers never collide.
 */
export const stepperContextKey = Symbol('nx-stepper-context') as InjectionKey<StepperRegistry>;
